export default function setup() {
    $(document).ready(function () {
        // Function to initialize event handlers for the form
        function initializeFormHandlers() {
            // Custom submit button click event
            $('.login-button').on('click', function () {
                // Collect the form data
                var formData = $('#signInForm').serialize();

                // Send the form via AJAX
                $.ajax({
                    url: '/Authentication/PopUpLogin',  // The action method that handles the form submission
                    type: 'POST',
                    data: formData,
                    success: function (response) {
                        if (response.success) {
                            // If success, perform the redirect
                            window.location.href = response.redirectUrl;
                        } else {
                            // If failed, replace the form with the new partial view
                            $('.login-popup-form').html(response);

                            // Re-initialize handlers after replacing the HTML
                            initializeFormHandlers();
                        }
                    },
                    error: function (xhr, status, error) {
                        // Handle errors (e.g., validation issues)
                        console.log("Error occurred: " + error);
                    }
                });
            });

            // Sign-up button click event
            $('#signupButton').on('click', function () {
                window.location.href = '/authentication/login';
            });
        }

        function initializeFormLogoutHandlers() {
            //loadLiteProfile();
            loadMyBoatsCount();
            loadSavedBoatsCount();
        }

        //function loadLiteProfile() {
        //    $.ajax({
        //        url: '/Account/GetFullNameMember',  // The action method that handles the form submission
        //        type: 'Get',
        //        success: function (data) {
        //            $("#profileName").text(data)
        //        },
        //        error: function (xhr, status, error) {
        //            // Handle errors (e.g., validation issues)
        //            console.log("Error occurred: " + error);
        //        }
        //    });
        //}

        function loadMyBoatsCount() {
            $.ajax({
                url: '/Boat/GetBoatsCount',  // The action method that handles the form submission
                type: 'Get',
                success: function (data) {
                    $("#myInventoryCount").text(data)
                },
                error: function (xhr, status, error) {
                    // Handle errors (e.g., validation issues)
                    console.log("Error occurred: " + error);
                }
            });
        }

        function loadSavedBoatsCount() {
            $.ajax({
                url: '/Boat/GetSavedBoatsCount',  // The action method that handles the form submission
                type: 'Get',
                success: function (data) {
                    $("#savedBoatsCount").text(data)
                },
                error: function (xhr, status, error) {
                    // Handle errors (e.g., validation issues)
                    console.log("Error occurred: " + error);
                }
            });
        }

        if (!window.location.href.includes('/authentication/login')) {
            // Load the form initially and bind events
            $('.login-popup-form').load('/Authentication/PopUpLogin', function () {
                // Initialize handlers for the form once it's loaded
                initializeFormHandlers();
                initializeFormLogoutHandlers();
            });
        }
        else
        {
            $('.login-popup-form').addClass('d-none');
        }

       // Show the popup on hover
        $('.login-popup').hover(function () {
            $('.login-popup-form').addClass('show');
        }, function () {
            if (!$('.login-popup-form').find('input:focus').length) {
                $('.login-popup-form').removeClass('show');
            }
        });

        // Keep the popup form visible on hover or when an input is focused
        $('.login-popup-form').on('mouseenter', function () {
            $(this).addClass('show');
        }).on('mouseleave', function () {
            if (!$(this).find('input:focus').length) {
                $(this).removeClass('show');
            }
        });
    });
}

